'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface DesktopNavProps {
  urlPrefix: string
  isAdmin: boolean
}

const navItems = [
  { label: 'Book', href: '/bookings' },
  { label: 'Bookings', href: '/my-bookings' },
  { label: 'Updates', href: '/updates' },
  { label: 'Account', href: '/account' },
]

export function DesktopNav({ urlPrefix, isAdmin }: DesktopNavProps) {
  const pathname = usePathname()

  // Guard: don't render Admin link if urlPrefix is invalid
  const adminHref = urlPrefix ? `${urlPrefix}/admin` : null
  const isInAdmin = adminHref && pathname.startsWith(adminHref)

  return (
    <nav className="flex items-center gap-6">
      {navItems.map((item) => {
        const href = `${urlPrefix}${item.href}`
        const isActive = pathname === href || pathname.startsWith(`${href}/`)

        return (
          <Link
            key={item.href}
            href={href}
            className={`text-sm font-medium transition-colors ${
              isActive
                ? 'text-white'
                : 'text-white/50 hover:text-white'
            }`}
          >
            {item.label}
          </Link>
        )
      })}

      {/* Admin Link (direct, no dropdown) */}
      {isAdmin && adminHref && (
        <Link
          href={adminHref}
          className={`text-sm font-medium transition-colors ${
            isInAdmin
              ? 'text-white'
              : 'text-white/50 hover:text-white'
          }`}
        >
          Admin
        </Link>
      )}
    </nav>
  )
}
